import { Box, UnstyledButton } from "@dehub/theme";
import { CheckIcon } from "@phosphor-icons/react";
import { useTranslation } from "react-i18next";
import bz from "@/features/business/business.module.css";
import { ReasonTooltip } from "@/shared/a11y/reason-tooltip";

export type BranchStep = 1 | 2;
const STEPS: BranchStep[] = [1, 2];

type Props = Readonly<{
  current: BranchStep;
  done: ReadonlySet<BranchStep>;
  /** Why a step cannot be opened right now; null when it can. */
  lockedReason: (step: BranchStep) => string | null;
  onGo: (step: BranchStep) => void;
}>;

export function BranchStepIndicator({ current, done, lockedReason, onGo }: Props) {
  const { t } = useTranslation("sector");

  return (
    <Box component="ol" className={bz.steps}>
      {STEPS.map((step) => {
        const reason = lockedReason(step);
        const isDone = done.has(step) && current !== step;
        return (
          <Box key={step} component="li" className={bz.stepsItem}>
            <ReasonTooltip reason={reason}>
              <UnstyledButton
                className={bz.step}
                data-active={current === step || undefined}
                data-done={isDone || undefined}
                aria-current={current === step ? "step" : undefined}
                onClick={() => onGo(step)}
              >
                <Box component="span" className={bz.stepNumber}>
                  {isDone ? <CheckIcon size={14} weight="bold" aria-hidden="true" /> : step}
                </Box>
                <Box component="span" className={bz.stepLabel}>
                  {t(`steps.s${step}.label`)}
                </Box>
              </UnstyledButton>
            </ReasonTooltip>
          </Box>
        );
      })}
    </Box>
  );
}
